var _effectorFileName = "/builds/gmini/front-ui-kit/src/FormulaeEditorLayout/FormulaeEditorLayout.tsx";
import Scrollbars from 'react-custom-scrollbars';
import styled from 'styled-components';
import { Box } from '../Box';
import { Backdrop as BackdropInit } from '../Backdrop';
import { LinearProgress } from '../LinearProgress';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FormulaeEditorLayout = ({
  disabled,
  children,
  maxWidth = '724px',
  height = '100%'
}) => /*#__PURE__*/_jsx(Scrollbars // eslint-disable-next-line react/forbid-component-props
, {
  style: {
    height,
    width: '100%',
    flexGrow: 1
  },
  children: /*#__PURE__*/_jsxs(Box, {
    position: "relative",
    height: "100%",
    maxWidth: maxWidth,
    pr: "24px",
    children: [/*#__PURE__*/_jsx(Backdrop, {
      open: disabled,
      children: /*#__PURE__*/_jsx(LinearProgress, {})
    }), children]
  })
});
const Backdrop = styled(BackdropInit)({
  position: 'absolute',
  zIndex: 100000,
  alignItems: 'flex-start',
  backgroundColor: 'rgba(255, 255, 255, 0.7)'
});